// MN Quick Add (global) — AJAX add-to-cart
(function () {
  function closestForm(target) {
    return target.closest('.mn-mncard__form, .mn-mncard__variantForm');
  }

  async function addToCart(form) {
    const fd = new FormData(form);
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    });
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  }

  async function refreshCartCount() {
    try {
      const r = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await r.json();
      document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
      });
    } catch (e) {}
  }

  document.addEventListener('submit', async (e) => {
    const form = closestForm(e.target);
    if (!form) return;

    // ✅ STOP normal submit + STOP other JS listeners (prevents double add)
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    // ✅ LOCK so it can’t fire twice (double click or duplicate listeners)
    if (form.dataset.mnAdding === '1') return;
    form.dataset.mnAdding = '1';

    const btn = form.querySelector('button[type="submit"]');
    const prevText = btn ? btn.textContent : null;

    try {
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'ADDING...';
      }

      await addToCart(form);
      refreshCartCount();

      if (btn) btn.textContent = 'ADDED ✓';
      setTimeout(() => {
        if (btn) {
          btn.disabled = false;
          btn.textContent = prevText || 'QUICK ADD +';
        }
      }, 900);

    } catch (err) {
      console.error(err);
      if (btn) {
        btn.disabled = false;
        btn.textContent = prevText || 'QUICK ADD +';
      }
    } finally {
      // ✅ UNLOCK
      form.dataset.mnAdding = '0';
    }
  }, true);
})();